<ng-container *ngIf="viewMode === 'form'">
  <input type="file" #fileInput (change)="onFileChange($event)">
  <button mat-flat-button color="primary" (click)="fileInput.click()">CHOISIR FICHIER</button>
  <span *ngIf="filenames$ | async as filenames">{{ filenames }}</span>
</ng-container>
<ellipse-dynamic-summary-field *ngIf="viewMode === 'summary'"
                               [label]="dynamicFormField.label"
                               [value]="dynamicFormField.formControl.value"/>
